// extracted by mini-css-extract-plugin
export default {"home":"HomePage_home__2sKSk","recent":"HomePage_recent__Ucz--","file":"HomePage_file__T-mAX","loadingWrapper":"HomePage_loadingWrapper__UrJcc"};